import assert from 'assert-ts';
import {MockCountRange} from '../../config/types';
import {getInRange} from './getInRange';
import {TemplateSets} from './types';

export const generateFromTemplate = <TTemplate, TData>(
  templateSets: TemplateSets<TTemplate>,
  range: MockCountRange | undefined,
  generator: (template: TTemplate, index: number) => TData,
): TData[] => {
  const count = getInRange(range);
  if (count === 0) return [];

  let templates = templateSets[count];
  if (!templates) {
    assert.soft(
      templates,
      'generateFromTemplate: templates not configured for count',
      {count, templateSets},
    );
    templates = templateSets[parseInt(Object.keys(templateSets)[0])];
  }

  const templateIdx = getInRange([0, templates.length - 1]);
  return templates[templateIdx].map(generator);
};
